module.exports = __webpack_public_path__ + "img/trick.cb0be164.jpg";